import { Link } from "@tanstack/react-router";


export function SiteFooter() {
  return (
    <footer role="contentinfo" className="mt-32 border-t border-border/60 bg-card">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-3 lg:grid-cols-7">
        <div>
          <span className="font-serif text-2xl tracking-tight">Pluggz.</span>
          <p className="mt-3 max-w-xs text-sm text-muted-foreground">A curated affiliate marketplace where creators and brands meet.</p>
        </div>
        <div>
          <p className="editorial-eyebrow mb-3">Shop</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/discover" className="block py-1 text-muted-foreground hover:text-foreground transition">Discover</Link></li>
            <li><Link to="/creators" className="block py-1 text-muted-foreground hover:text-foreground transition">Creators</Link></li>
            <li><Link to="/wishlist" className="block py-1 text-muted-foreground hover:text-foreground transition">Wishlist</Link></li>
            <li><Link to="/journal" className="block py-1 text-muted-foreground hover:text-foreground transition">Journal</Link></li>
            <li><Link to="/journal/guide-to-creator-storefronts" className="block py-1 text-muted-foreground hover:text-foreground transition">Creator storefront guide</Link></li>
          </ul>
        </div>
        <div>
          <p className="editorial-eyebrow mb-3">Creators</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/creator-dashboard" className="block py-1 text-muted-foreground hover:text-foreground transition">Dashboard</Link></li>
            <li><Link to="/apply" className="block py-1 text-muted-foreground hover:text-foreground transition">Apply</Link></li>
            <li><Link to="/login" className="block py-1 text-muted-foreground hover:text-foreground transition">Sign in</Link></li>
            <li><Link to="/signup" className="block py-1 text-muted-foreground hover:text-foreground transition">Sign up</Link></li>
          </ul>
        </div>
        <div>
          <p className="editorial-eyebrow mb-3">For Brands</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/advertise" className="block py-1 text-muted-foreground hover:text-foreground transition">Advertise</Link></li>
            <li><Link to="/contact" className="block py-1 text-muted-foreground hover:text-foreground transition">Contact</Link></li>
          </ul>
        </div>
        <div>
          <p className="editorial-eyebrow mb-3">Platform</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/demo" className="block py-1 text-muted-foreground hover:text-foreground transition">Interactive demo</Link></li>
            <li><Link to="/leaderboard" className="block py-1 text-muted-foreground hover:text-foreground transition">Leaderboard</Link></li>
            <li><Link to="/contact" className="block py-1 text-muted-foreground hover:text-foreground transition">Contact</Link></li>
          </ul>
        </div>
        <div>
          <p className="editorial-eyebrow mb-3">Pluggz</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy" className="block py-1 text-muted-foreground hover:text-foreground transition">Privacy</Link></li>
            <li><Link to="/terms" className="block py-1 text-muted-foreground hover:text-foreground transition">Terms</Link></li>
            <li><Link to="/privacy-settings" className="block py-1 text-muted-foreground hover:text-foreground transition">Privacy settings</Link></li>
          </ul>
        </div>
        <div>
          <p className="editorial-eyebrow mb-3">Categories</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/category/$slug" params={{ slug: "womens-fashion" }} className="block py-1 text-muted-foreground hover:text-foreground transition">Women's Fashion</Link></li>
            <li><Link to="/category/$slug" params={{ slug: "beauty-skincare" }} className="block py-1 text-muted-foreground hover:text-foreground transition">Beauty & Skincare</Link></li>
            <li><Link to="/category/$slug" params={{ slug: "mother-baby" }} className="block py-1 text-muted-foreground hover:text-foreground transition">Mother & Baby</Link></li>
            <li><Link to="/category/$slug" params={{ slug: "home-decor" }} className="block py-1 text-muted-foreground hover:text-foreground transition">Home & Decor</Link></li>
            <li><Link to="/category/$slug" params={{ slug: "fitness-wellness" }} className="block py-1 text-muted-foreground hover:text-foreground transition">Fitness & Wellness</Link></li>
            <li><Link to="/category/$slug" params={{ slug: "shoes-accessories" }} className="block py-1 text-muted-foreground hover:text-foreground transition">Shoes & Accessories</Link></li>
            <li><Link to="/category/$slug" params={{ slug: "cooking-grocery" }} className="block py-1 text-muted-foreground hover:text-foreground transition">Cooking & Grocery</Link></li>
            <li><Link to="/category/$slug" params={{ slug: "finance-lifestyle" }} className="block py-1 text-muted-foreground hover:text-foreground transition">Finance & Lifestyle</Link></li>
            <li><Link to="/category/$slug" params={{ slug: "travel" }} className="block py-1 text-muted-foreground hover:text-foreground transition">Travel</Link></li>
            <li><Link to="/category/$slug" params={{ slug: "grwm" }} className="block py-1 text-muted-foreground hover:text-foreground transition">GRWM</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border/60 px-6 py-6 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} Pluggz. Curated in London.
      </div>
    </footer>
  );
}
